import { ReactElement, useContext } from "react";
import { MixPanelUser, MixPanelWrapper } from "./MixPanelWrapper";
import { AuthContext, AuthStatus } from "../contexts/AuthContext";

export function MixPanelWrapperRegular(props: {children: ReactElement | ReactElement[]}): ReactElement {
    const {user, authStatus} = useContext(AuthContext);
    let mixpanelUser: MixPanelUser | null = null;

    if (user) {
        mixpanelUser = {
            ...user,
            assignedPropertyCount: user?.properties?.length ?? 0,
        };
    }
    return <MixPanelWrapper user={authStatus === AuthStatus.SignedIn ? mixpanelUser : null} {...props}/>;
}